import { Component, Input, Inject, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { IAppState } from '../../app.state';
import { toggleFullscreen, showTodosPanel } from '../../visual/visual.actions';
import { setShareTitle } from '../share.actions';
import { NIM_AUTH_TYPE } from '../../auth-form/auth.model';
import { ProfileService } from '../../profile/profile.service';
import { Config } from "../../universal-config";
import { CAPTURE_ROLES } from "./note.service";
import { isOrgSubscription } from '../../../model/organization.model';
import { MetricsService } from '../../metrics.service';

@Component({
  selector: 'nns-note',
  styles: [`
    :host {
      padding:0 0 16px 0;
    }
    :host .wrapper {
      max-width:100%;
      min-width:320px;
      padding:0 10px;
      position:relative;
      box-sizing:border-box;
      margin:0 auto;
    }
    :host nns-note-text{
      max-width: 950px;
      margin: 0 auto;
      position: relative;
      z-index: 1;
    }
    :host.nns-fullscreen {
      padding:16px 0;
    }
    :host.nns-fullscreen nns-note-text {
      max-width:1280px;
    }
    :host.nns-fullscreen .note-title-wrapper,
    :host.nns-fullscreen .note-top-holder {
      max-width:1280px;
    }

    ::ng-deep nns-note-text-version-2 .nedit-root{
      max-width: 950px;
    }

    :host.nns-fullscreen ::ng-deep nns-note-text-version-2 .nedit-root{
      max-width: 1280px;
    }


    .note-title-wrapper{
      padding:0 40px 16px 0;
      margin:0 auto;
      word-wrap: break-word;
      max-width: 950px;
      position: relative;
      display: flex;
      box-sizing: border-box;
    }
    .note-title-wrapper:hover .note-title-edit{
      opacity: 1;
    }
    h1.note-title {
      font-size:21px;
      line-height:1.3;
      margin: 0;
    }
    .note-title-edit{
      position: absolute;
      left: -28px;
      top: calc(50% - 16px);
      opacity: 0;
      transition: 0.3s;
      cursor: pointer;
    }
    .note-title-edit nns-icon{
      min-width: 16px;
      min-height: 16px;
    }
    .note-title-input{
      width: 100%;
      border: none;
      resize: none;
      font-size:21px;
      line-height:1.3;
      padding: 0;
      box-sizing: border-box;
      flex: 1;
      font-weight: bold;
      overflow: hidden;
      height: 27px;
    }

    nns-outline-btn {
      position: absolute;
      right: 0;
    }

    @media only screen and (max-width: 768px) {
      :host {
        padding:16px 0;
      }
      .note-title-wrapper{
        margin-left: 10px;
        margin-right: 10px;
      }
      h1.note-title {
        font-size: 18px;
      }
      .note-top-holder{
        margin-left: 10px!important;
        margin-right: 10px!important;
      }
      :host.nns-fullscreen  .wrapper {
        padding:0 10px;
      }
    }

    .note-top-holder {
      max-width: 950px;
      margin: 0 auto 10px auto;
      border-bottom:1px solid #dcdcdc;
    }
    .note-top {
      padding:0 0 16px 0;
    }

    nns-note-actions {
      margin: 0 -8px;
    }

    .note-text-date {
      font-size:16px;
      color:#3d3d3d;
    }

    .note-auth-form {
      padding: 40px 0px 170px;
      display: flex;
      justify-content: center;
    }

    nns-todo {padding:0;}

    nns-image {
      cursor: pointer;
      display:block;
      padding: 0 0 16px;
    }

    nns-image /deep/ img {
      display:block;
      max-width:100%;
      height:auto;
    }
    .nns-get-capture-wrapper{
      display: flex;
      justify-content: center;
      padding: 20px 0 170px;
    }
    .nns-get-capture{
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
    .nns-get-capture--title{
      font-weight: 500;
    }
    .nns-get-capture--btn{
      margin: 8px auto 0;
      background-color: rgba(0, 161, 183, 1);
      padding: 10px 30px;
      font-size: 13px;
      font-weight: 700;
      border-radius: 30px;
      color: #F5F8FA;
    }
  `, `
    :host-context(.nns-theme-night) .note-top-holder {
      border-color:rgba(255,255,255,0.12);
    }
    :host-context(.nns-theme-night) .note-top-download a {
      color:#0095A7;
    }
    :host-context(.nns-theme-night) .note-title-input{
      background-color: #2F3737;
      color: #fff;
    }
    :host-context(.nns-embed) .note-title-wrapper{
      padding-top: 20px;
    }
    :host-context(.nns-embed__video){
      padding: 0;
    }
    :host-context(.nns-embed__video) .wrapper{
      padding: 0;
    }
    :host-context(.nns-fullwidth) .note-top-holder,
    :host-context(.nns-fullwidth) .note-title-wrapper {
      max-width: 100%;
      margin-left: 30px;
      margin-right: 30px;
    }
    :host-context(.nns-fullwidth) .nns-note-wrapper{
      margin-right: 20px;
      margin-left: 20px;
    }

    :host-context(.nns-fullwidth) ::ng-deep nns-note-text-version-2 .nedit-root {
      max-width: 100%;
    }
    :host-context(.nns-fullwidth) ::ng-deep .editor-body{
      overflow-y: unset;
    }
    @media only screen and (max-width: 1000px) {
      .note-title-wrapper{
        padding-left: 10px;
        padding-right: 10px;
      }
      :host-context(.nns-fullwidth) .note-title-wrapper{
        padding-left: 0;
        padding-right: 0;
      }
      .note-top-holder{
        margin-left: 10px;
        margin-right: 10px;
      }
    }
    @media only screen and (max-width: 768px) {
      :host-context(.nns-embed) .note-title-wrapper{
        padding-top: 0;
      }
      :host-context(.nns-fullwidth) .nns-note-wrapper{
        margin-left: 0;
        margin-right: 0;
      }
      :host-context(.nns-fullwidth) .note-top-holder,
      :host-context(.nns-fullwidth) .note-title-wrapper {
        margin-left: 10px;
        margin-right: 10px;
      }
      .note-title-wrapper{
        padding-left: 0;
        padding-right: 0;
      }
      .note-auth-form, .nns-get-capture-wrapper{
        display: none;
      }
    }
  `],
  template: `
    <div class="wrapper nns-animated">
      <nns-attachments class="nns-attachments-opened mobile"
        *ngIf="visual.isMobile && activeTab == 2"
        [attachments]="attachmentsInList"
        [attachmentBases]="attachmentBases"
      ></nns-attachments>
      <nns-todos
        *ngIf="visual.isMobile && activeTab == 3"
        [todosOrder]="note.todosOrder"
        [todos]="todos"
      ></nns-todos>
      <div class="note-content"
        *ngIf="!visual.isMobile || activeTab == 1"
      >
        <div class="note-title-wrapper"
          *ngIf="note?.title && !(visual.isEmbed && (visual.isVideo || note.role == 'screenshot'))"
          (clickOutside)="onTitleClickOutside()">
          <h1 class="note-title"
            *ngIf="!isTitleEdit"
            class="note-title font-{{visual.noteFont}}"
            [innerHTML]="note.title"
            ></h1>

          <textarea
            id="titleInput"
            class="note-title-input font-{{visual.noteFont}}"
            *ngIf="isTitleEdit"
            wrap="hard"
            [innerHTML]="note.title"
            (keyup)="titleKeyUpHandler($event)"
            (keyup.enter)="onTitleEnter($event)"
          ></textarea>

          <div class="note-title-edit"
            *ngIf="!isTitleEdit && showShareConfig"
            (click)="openTitleEdit()">
            <nns-icon icon="pencil"></nns-icon>
          </div>
          <nns-outline-btn
            *ngIf="isShowOutlinesBtn"
            [isActive]="visual.isShowOutlines"
            [title]="outlinesButtonTitle"
          ></nns-outline-btn>
        </div>

        <div class="note-top-holder" *ngIf="!visual?.isEmbed">
          <div class="note-top not-mobile"
            *ngIf="isShowAttachments || isShowTodos"
          >
            <div class="nns-note-actions-container" flex="none" layout="row" layout-align="start center">
              <nns-note-actions
                [attachments]="attachmentsInList"
                [todos]="todos"
                [note]="note"
                (attachmentsToggled)="toggleAttachments($event)"
                (todosToggled)="toggleTodos($event)"
                flex layout="row" layout-align="start center"
                title="Click to show files"
              ></nns-note-actions>
            </div>

            <nns-attachments
              *ngIf="isShowAttachments && isOpenAttachments"
              [attachments]="attachmentsInList"
              [attachmentBases]="attachmentBases"
              class="nns-attachments-opened"
            ></nns-attachments>
          </div>
        </div>
        <div class="nns-note-wrapper" *ngIf="!visual.isPreview">
          <nns-video-player
            *ngIf="note.isVideoNote && isBrowser"
            [attachment]="note.videoNote"
            [maxWidth]="maxVideoWidth"
            [maxHeight]="maxVideoHeight"
          >
          </nns-video-player>
          <nns-video-loader
            *ngIf="note.isVideoNote && !isBrowser"
          ></nns-video-loader>
          <nns-image
            *ngIf="note.isImageNote"
            [attachment]="note.imageNote"
            (click)="openImageAttachment(note.imageNote)"
          ></nns-image>

          <nns-note-text *ngIf="text?.text && text?.version !== 2"
            [text]="text.text | safeHtml"
            [attachments]="attachments"
          ></nns-note-text>

          <nns-note-text-version-2 *ngIf="text?.version === 2"
            [note]="note"
            [attachments]="attachments"
            [share]="share?.instance"
            [visual]="visual"
            [branding]="branding"
            [profile]="profile"
          ></nns-note-text-version-2>

          <div class="note-auth-form" *ngIf="showAuthForm && !isCapture">
            <nim-webshare-auth-form
              [viewType]="2"
              [isShowClose]="profile && (profile.userId === share.instance.userId)"
              [authType]="currentAuthType"
              [isDisabled]="!!profile"
              [upgradeLink]="upgradeLink"
              [termsLink]="termsUrl"
              [otpLink]="contactUrl"
              [authUrl]="authUrl"
              (nimClose)="handleAuthClose()"
              (nimSubmit)="handleSignup($event)"
            ></nim-webshare-auth-form>

          </div>
          <div class="nns-get-capture-wrapper" *ngIf="showAuthForm && isCapture">
            <div class="nns-get-capture">
              <div class="nns-get-capture--title">
                🔥 Want to make awesome screenrecords and screenshots?
              </div>
              <a href="https://thefusebase.com/screenshot/" target="_blank" class="nns-get-capture--btn">Get your Fusebase Pro today!</a>
            </div>
          </div>

        </div>
      </div>
    </div>
  `
})
export class NoteComponent {
  @Input() public profile;
  @Input() public text;
  @Input() public note;
  @Input() public attachments;
  @Input() public todos;
  @Input() public share;
  @Input() public visual;
  @Input() public activeTab;
  @Input() public branding;
  @Input() public showShareConfig;
  @Input() public isShowOutlinesBtn;
  @Input() public outlinesButtonTitle;
  todosOrder = [];
  todosUnchecked = [];
  maxVideoWidth;
  maxVideoHeight;
  attachmentsInList;
  attachmentBases;
  dateString;
  isShowAttachments = false;
  isShowTodos = false;
  isOpenAttachments = true;
  isTitleEdit: boolean;
  titleTextLength;
  currentAuthType: NIM_AUTH_TYPE = NIM_AUTH_TYPE.SIGNUP;
  upgradeLink: string;
  showAuthForm: boolean;
  termsUrl: string;
  contactUrl: string;
  authUrl: string;
  isCapture;

  constructor(
    public _store: Store<IAppState>,
    public _router: Router,
    public _profileService: ProfileService,
    @Inject('isBrowser')public isBrowser: boolean,
    private config: Config,
    private metrics: MetricsService
  ) {
    this.authUrl = this.config.get('AUTH_API_URL');
  }

  toggleFullscreen() {
    this._store.dispatch(toggleFullscreen());
  }

  ngOnInit() {
    const { attachmentBase, videoAttachmentBase } = this.share;
    this.attachmentBases = { attachmentBase, videoAttachmentBase };

    this.refreshAttachments();

    this.dateString = new Date(this.note.dateUpdatedUser * 1000).toLocaleString(
      "en-US", {
        year: "numeric",
        month: "long",
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      }
    );
    this.setUpgradeLink();
    this.setTermsLink();

    if (window['_shareStartLoad']) {
      const timing = Date.now() - window['_shareStartLoad'];
      this.metrics.sendTiming('share_page_note_title', timing);
    }
  }

  ngOnChanges(changes) {
    this.refreshAttachments();
    this.setVideoSizes();
    this.isShowAttachments = this.detectShowAttachments();
    if (this.todos && this.todos.length && this.todos.filter((todo) => !todo.checked)) {
      this.isShowTodos = true;
      this.todosUnchecked = this.todos.filter((todo) => !todo.checked);
    } else {
      this.isShowTodos = false;
      this.todosUnchecked = [];
    }
    if(changes.profile || changes.share || changes.visual) {
      this.setIsShowAuthForm();
    }
    if(changes.note) {
      if(this.note && CAPTURE_ROLES.includes(this.note.role)) {
        this.isCapture = true;
      } else {
        this.isCapture = false;
      }
    }
  }

  setIsShowAuthForm() {
    const isNotMyShare = this.profile && this.profile.userId != this.share.instance.userId;
    const { orgInfo } = this.share.instance;
    const isPremiumSubscription = isOrgSubscription('premium')(orgInfo);
    const isBusinessSubscription = isOrgSubscription('business')(orgInfo);
    const isEmbed = this.visual.isEmbed;
    const { isShareAdEnabled, userId } = orgInfo;
    const isOrgOwner = this.profile && this.profile.userId == userId;

    if (
      isEmbed || isNotMyShare || isBusinessSubscription ||
      (isPremiumSubscription && isOrgOwner) ||
      (isPremiumSubscription && !isOrgOwner && !isShareAdEnabled)
    ) {
      this.showAuthForm = false;
    } else {
      this.showAuthForm = true;
    }
  }

  setVideoSizes() {
    this.maxVideoHeight = 600;
    if (this.visual.isFullscreen) {
      this.maxVideoWidth = Math.min(this.visual.windowWidth, 1280) - 20;
    } else {
      this.maxVideoWidth = Math.min(this.visual.windowWidth, 970) - 20;
    }
  }

  refreshAttachments() {
    if (this.attachments && this.attachments.length) {
      this.attachmentsInList = this.attachments.filter((item) => item.inList);
    } else {
      this.attachmentsInList = [];
    }
  }

  openImageAttachment(attachment) {
    if (!attachment) {
      console.error("NoteComponent: No attachment to open");
    }
    this._router.navigate([attachment.imageURL]);
  }

  findAttachment(attachmentId) {
    let attachment;
    this.attachments.forEach((a) => {
      if (a.globalId === attachmentId) {
        attachment = a;
      }
    });
    return attachment;
  }

  toggleAttachments(state) {
    this.isOpenAttachments = state;
  }

  toggleTodos(state) {
    this._store.dispatch(showTodosPanel());
  }

  detectShowAttachments() {
    if (this.attachmentsInList && this.attachmentsInList.length) {
      if (this.note.isImageNote && this.attachmentsInList.length === 1
        && (this.attachmentsInList[0].type === 'image')
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  openTitleEdit() {
    this.isTitleEdit = true;
    this.focusOnTitle();
  }

  onTitleClickOutside() {
    this.isTitleEdit = false;
  }

  titleKeyUpHandler($event) {
    if ($event) {
      const element = $event.target
      if (element.textLength < this.titleTextLength) {
        element.style.height = '28px'
      }
      this.titleTextLength = element.textLength
      element.style.height = element.scrollHeight + 'px'
    }
  }

  focusOnTitle() {
    setTimeout(() => {
      const element: any = document.getElementById('titleInput');
      if (element) {
        this.titleTextLength = element.textLength;
        element.style.height = element.scrollHeight + 'px';
        element.focus()
        const titleLength = this.note.title.length;
        element.setSelectionRange(titleLength, titleLength);
      }
    })
  }

  onTitleEnter($event) {
    const element: any = document.getElementById('titleInput');
    const value = element.value
    this.isTitleEdit = false;
    const title = this.prepareTitle(value);
    if(title.length) {
      this._store.dispatch(setShareTitle(title));
    }
  }

  prepareTitle(title) {
    return title.trim().replace(/\r?\n/g, "");
  }

  handleAuthClose() {
    if (this.currentAuthType === NIM_AUTH_TYPE.REMOVE) {
      this.currentAuthType = NIM_AUTH_TYPE.SIGNUP;
    } else {
      this.currentAuthType = NIM_AUTH_TYPE.REMOVE;
    }
  }

  handleSignup(formResult) {
    this._profileService.applyAuth(formResult, this.currentAuthType, 'footer');
    this._profileService.showSignUpSuccessToast();
  }

  setUpgradeLink() {
    const nimbusUpgradeLink = this.config.get('NIMBUS_UPGRADE_URL');
    this.upgradeLink = `${nimbusUpgradeLink}?sharing_page_banner=reg_form_upgrade`;
  }

  setTermsLink() {
    this.termsUrl = this.config.get('NIMBUS_TERMS_URL');
    this.contactUrl = this.config.get('NIMBUS_CONTACT_URL');
  }

  @HostListener('document:keydown.esc', ['$event'])
  closeFullScreen() {
    if(this.isTitleEdit) {
      this.isTitleEdit = false;
    }
  }
}
